<template>
  <div class="alerts">
    <h2>Notifications</h2>
    <loading message="Loading notification summaries" :loading="isLoading">
      <b-card-group columns v-if="page && outstandingCount > 0">
        <div v-for="category in page.Summary" :key="category.code">
          <b-card
            v-if="category.count !== 0"
            :title="category.count | commas | prefix('#')"
            :sub-title="category.summary">
            <p class="card-text"><i :class="`fas fa-${category.icon}`"></i> {{ category.long_description }}</p>
            <b-link :to="`/alerts/${category.code}`" class="card-link">View notifications</b-link>
          </b-card>
        </div>
      </b-card-group>
      <div v-if="outstandingCount == 0">
        <p>Congratulations! You have no more outstanding notifications for this month.</p>
        <celebrate/>
      </div>
    </loading>
  </div>
</template>

<script>
import Loading from '../components/Loading.vue'
import Celebrate from '../components/Celebrate.vue'

export default {
  name: 'alerts',
  components: { Loading, Celebrate },
  data() {
    return {
      isLoading: false,
      error: null,
      page: null,
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    outstandingCount() {
      if (!this.page || !this.page.Summary) {
        return -1;
      }
      return this.page.Summary.reduce((a, c) => a + c.count, 0);
    },
  },
  methods: {
    // TomM: removed caching from this call as I've adjusted the query to be much much faster
    // takes a few ms even when there are 17,000+ notifications for the authority. 😎
    getData() {
        // fetch from reporting api
        this.isLoading = true;
        const { access_token } = this.$store.state.oidcStore;
        return this.$reportingApi.renderPage('panessex', access_token, {
          pageName: 'Alerts',
        })
        .then((page) => {
          this.page = page; 
          this.isLoading = false;
        })
      .catch((e) => { 
        this.error = e.message; 
        this.isLoading = false; 
      });
    },
  }
}
</script>
